module.exports = __webpack_public_path__ + "blue-arrow.png";